import API from '../../../utils/API';
import { Post, Get, Put, Patch, Delete } from '../../../utils/callApi';

const ITEM_PER_PAGE = 10;
const GB_TO_BYTE = 1073741824;
const MB_TO_BYTE = 1048576;

const changeDateToString = (date) => {
  return ("0" + date.getDate()).slice(-2) + "/" + ("0" + (date.getMonth() + 1)).slice(-2) + "/" +date.getFullYear();
}


export const getListProject = async (body) => {
  const {page} = body; // <==>const page = body.page;
  const {success , data} = await Get(API.STORAGE.GET_LIST_PROJECT(page, ITEM_PER_PAGE));
  if(success){
    if(data.ErrorCode===0){
      const list_project = data.Result.docs.map((e) => {
        return {
          ...e,
          manager:{
            email: e.manager ? e.manager.email : '',
            phone: e.manager ? e.manager.sdt : '',
            name: e.manager ? e.manager.fullName : ''
          },
          dep_head:{
            email: e.dep_head ? e.dep_head.email : '',
            phone: e.dep_head ? e.dep_head.sdt : '',
            name: e.dep_head ? e.dep_head.fullName : ''
          },
          capacity: (Number(e.storage_size)/GB_TO_BYTE).toFixed(2),
          max_file_size: (e.max_file_size/MB_TO_BYTE).toFixed(2),
          update_date: changeDateToString(new Date(e.update_date))
        }
      })

      return {success: true, data: {
        projects: list_project,
        page: page,
        totalPage: data.Result.pages,
        totalProjects: data.Result.total,
      }};
    }
    return {
      success: false, data: {}
    }
  }
  return {
    success: false, data: {}
  }
}

export const addNewProject = async (body) => {
  // create dept_head
  const create_dept_head = await Post(API.USER.CREATE_USER_INFO, {
    email: body.dep_head.email,
    sdt: body.dep_head.phone,
    fullName: body.dep_head.name,
    department: body.department,
  });

  if(create_dept_head.success) {
    if(create_dept_head.data.ErrorCode === 0) {
      // create manager
      const create_manager = await Post(API.USER.CREATE_USER_INFO, {
        email: body.manager.email,
        sdt: body.manager.phone,
        fullName: body.manager.name,
        department: body.department,
      });
    
      if(create_manager.success) {
        if(create_manager.data.ErrorCode === 0) {
            // create project info
          let body_format = {
            dept_head : body.dep_head.email,
            manager : body.manager.email,
            department : body.department,
            description : body.description,
            project_name : body.account_name,
            storage_size : (+body.capacity)*GB_TO_BYTE,
            storage_time : +body.file_time,
            max_file_size : (+body.max_file_size)*MB_TO_BYTE,
            domain : body.domain
          }
          const {success, data} = await Post(API.STORAGE.ADD_NEW_PROJECT, body_format);
          if(success) {
            if(data.ErrorCode === 0){
                return getListProject({page:1});
            }
            if(data.ErrorCode === 410){
              return {
                success : false,
                data : {error: "Trưởng phòng không tồn tại."}
              };
            }
            if(data.ErrorCode === 405){
              return {
                success : false,
                data : {error: "Định dạng không hợp lệ."}
              };
            }
            if(data.ErrorCode === 403){
              return {
                success : false,
                data : {error: "Dự án đã tồn tại."}
              };
            }
            if(data.ErrorCode === 409){
              return {
                success : false,
                data : {error: "Dung lượng cấp vượt quá dung lượng còn lại của hệ thống."}
              };
            }
            return {
              success : false,
              data : {error: data.Message}
            };
          }else{
            return {
              success : false,
              data : {}
            }
          }    
        }
        return {
          success: false,
          data: {}
        }
      }else {
        return {
          success: false,
          data: {}
        }
      }
    }
    return {
      success: false,
      data: {}
    }
  
  }else{
    return {
      success: false,
      data: {}
    }
  }
}

export const editAProject = async (body) => {
  // create dept_head
  const create_dept_head = await Post(API.USER.CREATE_USER_INFO, {
    email: body.dep_head.email,
    sdt: body.dep_head.phone,
    fullName: body.dep_head.name,
    department: body.department,
  });

  if(create_dept_head.success) {
    if(create_dept_head.data.ErrorCode === 0) {
      // create manager
      const create_manager = await Post(API.USER.CREATE_USER_INFO, {
        email: body.manager.email,
        sdt: body.manager.phone,
        fullName: body.manager.name,
        department: body.department,
      });
    
      if(create_manager.success) {
        if(create_manager.data.ErrorCode === 0) {
            // create project info
          let body_format = {
            api_key: body.api_key,
            dept_head : body.dep_head.email,
            manager : body.manager.email,
            department : body.department,
            description : body.description,
            project_name : body.account_name,
            storage_size : (+body.capacity)*GB_TO_BYTE,
            storage_time : +body.file_time,
            max_file_size : (+body.max_file_size)*MB_TO_BYTE,
            domain : body.domain,
            reason: body.reason
          }
          const {success, data} = await Patch(API.STORAGE.EDIT_PROJECT, body_format);
          if(success) {
            if(data.ErrorCode === 0){
                return getListProject({page:1});
            }
            if(data.ErrorCode === 410){
              return {
                success : false,
                data : {error: "Trưởng phòng không tồn tại"}
              };
            }
            if(data.ErrorCode === 405){
              return {
                success : false,
                data : {error: "Định dạng không hợp lệ"}
              };
            }
            if(data.ErrorCode === 403){
              return {
                success : false,
                data : {error: "Dự án đã tồn tại"}
              };
            }
            if(data.ErrorCode === 409){
              return {
                success : false,
                data : {error: "Dung lượng cấp vượt quá dung lượng còn lại của hệ thống."}
              };
            }
            return {
              success : false,
              data : {error: data.Message}
            };
          }else{
            return {
              success : false,
              data : {}
            }
          }    
        }
      }else {
        return {
          success: false,
          data: {}
        }
      }
    }else{
      return {
        success: false,
        data: {}
      }
    }
  }else{
    return {
      success: false,
      data: {}
    }
  }
}

export const deleteAProject = async (body) => {
  const body_format = {
    api_key: body.api_key
  }

  const {success, data} = await Delete(API.STORAGE.DELETE_PROJECT, body_format);
  if(success){
    if(data.ErrorCode === 0){
      return getListProject({page:1});
    }
    return {
      success: false,
      data: {error:data.Message}
    }
  }
  return {
    success: false,
    data:{}
  }
}

export const exportDataProject = async (body) => {
  const {page} = body;
  const {success, data} = await Get(API.STORAGE.GET_LIST_PROJECT(page, ITEM_PER_PAGE));

  if(success) {
    if(data.ErrorCode === 0){
      const list_project = data.Result.docs.map((e) => {
        return {
          ...e,
          manager:{
            email: e.manager ? e.manager.email : '',
            phone: e.manager ? e.manager.sdt : '',
            name: e.manager ? e.manager.fullName : ''
          },
          dep_head:{
            email: e.dep_head ? e.dep_head.email : '',
            phone: e.dep_head ? e.dep_head.sdt : '',
            name: e.dep_head ? e.dep_head.fullName : ''
          },
          capacity: (Number(e.storage_size)/GB_TO_BYTE).toFixed(2),
          max_file_size: (e.max_file_size/MB_TO_BYTE).toFixed(2),
          update_date: changeDateToString(new Date(e.update_date))
        }
      })
      return {
        success: true,
        data: {
          exportData: list_project,
          exportPercent: page * 100 / Number(data.Result.pages)
        }
      }
    }
    return {
      success: false,
      data: {}
    }
  } else {
    return {
      success: false,
      data: {}
    }
  }
}